import types from './types';

const initialState = {
    confirmPassword: '',
    isLoading: false,
    isValidResetKey: false,
    networkError: false,
    newPassword: '',
    passwordResetSuccess: false,
    passwordsDoNotMatch: false,
    resetKey: '',
    userId: '',
    passwordCodeExpired: false,
    errorMessage: '',
};

const recalculatePasswordsDoNotMatch = (state) => {
    const { confirmPassword, newPassword } = state;

    return {
        ...state,
        passwordsDoNotMatch:
            confirmPassword && newPassword && newPassword !== confirmPassword,
    };
};

const updateStates = (state = initialState, action) => {
    switch (action.type) {
        case types.CHANGE_CONFIRM_PASSWORD:
            return {
                ...state,
                confirmPassword: action.payload,
                errorMessage: '',
            };

        case types.BLUR_CONFIRM_PASSWORD:
            return recalculatePasswordsDoNotMatch(state);

        case types.CHANGE_NEW_PASSWORD:
            return {
                ...state,
                newPassword: action.payload,
                errorMessage: '',
            };

        case types.BLUR_NEW_PASSWORD:
            return recalculatePasswordsDoNotMatch(state);

        case types.PASSWORDS_DO_NOT_MATCH:
            return { ...state, passwordsDoNotMatch: true };

        case types.RESET_PASSWORD_SUBMITTED:
            return {
                ...state,
                // reset some of these values each time its submitted
                // so states clear out
                passwordsDoNotMatch: false,
                errorMessage: '',
                networkError: false,
                isLoading: true,
            };

        case types.RESET_PASSWORD_FAILURE:
            return {
                ...state,
                networkError: true,
                isLoading: false,
            };

        case types.RESET_PASSWORD_FAILURE_ERROR_FOR_USER:
            return {
                ...state,
                errorMessage: action.payload,
                isLoading: false,
            };

        case types.RESET_PASSWORD_FAILURE_EXPIRED_CODE:
            return {
                ...state,
                passwordCodeExpired: true,
                isLoading: false,
            };

        case types.RESET_PASSWORD_SUCCESS:
            return {
                ...state,
                isLoading: false,
                passwordResetSuccess: true,
                returnUrl: action.returnUrl,
            };

        case types.RESET_KEY_INVALID:
            return {
                ...state,
                isValidResetKey: false,
            };

        case types.RESET_KEY_VALID:
            return {
                ...state,
                isValidResetKey: true,
            };

        default:
            return state;
    }
};

export default updateStates;
